import React from 'react';
import {
  TouchableOpacity,
  TouchableHighlight,
  TouchableWithoutFeedback,
  View,
  StyleSheet,
} from 'react-native';

import {
  IBaseTouchableProps,
  TouchableTypeEnum,
} from './touchableCommon';

const styles = StyleSheet.create({
  touchableWithoutFeedback: {
    // This is web styles on react-native do not have types for it
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    cursor: 'pointer',
  },
});

export function BaseTouchable({
  children,
  type,
  style,
  ...props
}: IBaseTouchableProps) {
  if (type === TouchableTypeEnum.Highlight) {
    return (
      <TouchableHighlight style={style} {...props}>
        {children}
      </TouchableHighlight>
    );
  }

  if (type === TouchableTypeEnum.WithoutFeedback) {
    return (
      <TouchableWithoutFeedback {...props}>
        <View style={[styles.touchableWithoutFeedback, style]}>
          {children}
        </View>
      </TouchableWithoutFeedback>
    );
  }

  return (
    <TouchableOpacity style={style} {...props}>
      {children}
    </TouchableOpacity>
  );
}
